import { Link } from 'react-router-dom';

// Links do rodape institucional. Conteudo da propria pagina, junto dela.
const LINKS = {
  produto: [
    { label: 'Recursos', href: '#recursos' },
    { label: 'Planos', href: '#planos' },
    { label: 'Demonstração', href: '#' },
    { label: 'Integrações', href: '#' },
  ],
  empresa: [
    { label: 'Sobre nós', href: '#' },
    { label: 'Blog', href: '#' },
    { label: 'Carreiras', href: '#' },
    { label: 'Contato', href: '#' },
  ],
  legal: [
    { label: 'Termos de uso', href: '#' },
    { label: 'Política de privacidade', href: '#' },
    { label: 'LGPD', href: '#' },
  ],
};
export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm">C</span>
              </div>
              <span className="font-semibold text-base tracking-tight text-foreground-900">
                Central Check
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              Gestão inteligente de condomínios para administradoras e síndicos que levam a
              conformidade a sério.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Produto</h4>
            <ul className="flex flex-col gap-2.5">
              {LINKS.produto.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Empresa</h4>
            <ul className="flex flex-col gap-2.5">
              {LINKS.empresa.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Legal</h4>
            <ul className="flex flex-col gap-2.5">
              {LINKS.legal.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            © 2026 Central Check. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-foreground-500 hover:text-primary-600 transition-colors"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-lg"></i>
            </a>
            <a
              href="#"
              className="text-foreground-500 hover:text-primary-600 transition-colors"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a
              href="#"
              className="text-foreground-500 hover:text-primary-600 transition-colors"
              aria-label="WhatsApp"
            >
              <i className="ri-whatsapp-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
